<div class="tml-tpl-input tam-contact-control contact-jobfunction" attr.tid="{{config.controlName}}">
    <kendo-multiselect #entitylist [style.width.px]="childConfig.css.width" [data]="suggestionItems" [filterable]="true"
        [popupSettings]="{appendTo: 'component'}" (filterChange)="handleFilter($event)" [disabled]="readOnly"
        (open)="onOpen($event)" [(ngModel)]="selectedItems" (focus)="entitylist.toggle(true)"
        (mousedown)="$event.preventDefault()" (valueChange)="valueChange($event)">
        <ng-template kendoMultiSelectItemTemplate let-dataItem>
            <span>{{dataItem}}</span>
        </ng-template>

        <ng-template kendoDropDownListFooterTemplate>
            <div *ngIf="searchValue" class="dropdown-fly-item" (click)="createJobFunction()">
                <span class='overflow-hidden'>{{searchValue}}</span>
                <span>(New job function)</span>
            </div>
        </ng-template>
    </kendo-multiselect>
    <label [hidden]="!hintContent" class="item-label-error">
        {{hintContent}}
    </label>
</div>
